<template>
  <div>
    <vx-card
      title="Update Cascade Fields"
      class="mt-5"
      v-if="showFieldSelection"
    >
      <p>
        On the left are the source fields. On the right are the fields for
        cascade.
      </p>

      <div class="flex">
        <div class="w-1/5 bg-grid-color-secondary">
          <vs-list>
            <vs-list-header
              title="Field Types"
              color="primary"
            ></vs-list-header>
            <template v-for="(slot, index) in sourceFieldgroups">
              <v-select
                ref="select"
                label="label"
                class="pb-15 pt-15"
                :options="source_field_types"
                :key="index"
                v-model="slot.sourceFieldType"
                style="height:80px;"
              />
            </template>
          </vs-list>
        </div>
        <!-- <div class="w-1/5 bg-grid-color">
          <vs-list>
            <vs-list-header
              title="Client"
              color="primary"
            ></vs-list-header>
            <template v-for="(slot, index) in sourceFieldgroups">
              <v-select
                label="label"
                class="pb-15 pt-15"
                :options="source_client_types"
                :key="index"
                v-model="slot.sourceFieldType"
                style="height:80px;"
              />
            </template>
          </vs-list>
        </div> -->
        <div class="w-1/2 bg-grid-color-secondary">
          <vs-list>
            <vs-list-header title=" Fields" color="primary"></vs-list-header>
            <template v-for="(slot, index) in sourceFieldgroups">
              <div class="vx-row" :key="index">
                <div class="vx-col w-full md:w-4/5">
                  <multiselect
                    v-model="slot.sourceField"
                    :options="source_options"
                    :multiple="false"
                    group-values="column_names"
                    group-label="group"
                    :group-select="false"
                    placeholder="Type to search"
                    track-by="name"
                    label="label"
                    style="height:80px;"
                  >
                    <span slot="noResult"
                      >Oops! No elements found. Consider changing the search
                      query.</span
                    >
                  </multiselect>
                </div>
              </div>
            </template>

            <span class="text-danger text-sm mb-10">{{
              validation_message
            }}</span>
          </vs-list>
        </div>
        <div class="w-1/5 bg-grid-color">
          <vs-list>
            <vs-list-header
              title="Field Types"
              color="primary"
            ></vs-list-header>
            <template v-for="(slot, index) in triggerFieldgroups">
              <v-select
                label="label"
                class="pb-15 pt-15"
                :options="trigger_field_types"
                :key="index"
                v-model="slot.triggerFieldType"
                style="height:80px;"
              />
            </template>
          </vs-list>
        </div>
        <div class="w-1/2 bg-grid-color-secondary">
          <vs-list>
            <vs-list-header title=" Fields" color="primary"></vs-list-header>
            <template v-for="(slot, index) in triggerFieldgroups">
              <div class="vx-row" :key="index">
                <div class="vx-col w-full md:w-4/5">
                  <multiselect
                    v-model="slot.triggerField"
                    :options="trigger_options"
                    :multiple="false"
                    group-values="column_names"
                    group-label="group"
                    :group-select="false"
                    placeholder="Type to search"
                    track-by="name"
                    label="label"
                    style="height:80px;"
                  >
                    <span slot="noResult"
                      >Oops! No elements found. Consider changing the search
                      query.</span
                    >
                  </multiselect>
                </div>
                <div class="vx-col w-full md:w-1/6"></div>
              </div>
            </template>
          </vs-list>
        </div>
      </div>
      <div class="text-right">
        <vs-button
        @click="submitSelectedFields"
        color="primary"
        type="filled"
        >Update</vs-button
      >
      </div>
     
    </vx-card>
  </div>
</template>

<script>
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
import defineAbilitiesFor from "@/config/abilities";
import ImportExcel from "@/components/excel/ImportExcel.vue";
import Prism from "vue-prism-component";
import vSelect from "vue-select";
import axios from "@/axios.js";
import _ from "lodash";
import Multiselect from "vue-multiselect";
// import MatchResults from "@/components/Match.vue"
export default {
  components: {
    ImportExcel,
    Prism,
    vSelect,
    CampaignAutocomplete,
    ClientAutocomplete,
    Multiselect
  },
  data() {
    return {
      cascadeFieldId: null,
      selected_client: null,
      new_csv_field_name: null,
      addNewColumnToCsvTablePopUp: false,
      temporary_csv_columns: [],
      campaign_required: null,
      selected_campaign_id: [],
      user_id: null,
      user_role: null,
      companySearchComponentKey: 0,
      master_fields: [],
      client_fields: [],
      campaign_fields: [],
      csv_table_columns: [],
      selected_db_fields: [],
      abilities: null,
      table_name_exists: null,
      upload_validation: false,
      upload_validation_message: null,
      file_name: null,
      table_name: null,
      csv_filename: null,
      validation_message: "",
      sourceFieldgroups: [
        {
          sourceFieldType: "",
          sourceField: ""
        }
      ],
      triggerFieldgroups: [
        {
          triggerFieldType: "",
          triggerField: ""
        }
      ],
      temp_campaign_accounts_columns: [],
      showFieldSelection: true,
      tableData: [],
      header: [],
      sheetName: "",
      campaign_clients: [],
      source_field_types: [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 2,
          name: "client_field",
          value: "client_field",
          label: "Client Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ],
      trigger_field_types: [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 2,
          name: "client_field",
          value: "client_field",
          label: "Client Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ],
      uploaded_columns: [],
      source_options: [],
      trigger_options: [],
      triggger_field_type: null,
      source_field_type: null
    };
  },
  computed: {
    sourceFieldType() {
      return this.sourceFieldgroups.map(slot => slot.sourceFieldType);
    },
    triggerFieldType() {
      return this.triggerFieldgroups.map(slot => slot.triggerFieldType);
    }
  },
  mounted() {
    this.getCascadedField();
  },
  watch: {
    sourceFieldType(val) {
      this.source_options = [];
      let source_field_type = val[val.length - 1];

      if (source_field_type.name == "master_field") {
        this.getSourceMasterFields();
        this.sourceFieldgroups[0].sourceField = {};
      }

      if (source_field_type.client) {
        this.getSourceClientFields(source_field_type.id);
        this.sourceFieldgroups[0].sourceField = {};
      }

      if (source_field_type.name == "client_field") {
        this.getSourceCampaignClients();
        this.sourceFieldgroups[0].sourceField = {};
      }

      if (source_field_type.name == "campaign_field") {
        this.getSourceCampaignFields();
        this.sourceFieldgroups[0].sourceField = {};
      }
    },
    triggerFieldType(val) {
      this.trigger_options = [];
      let trigger_field_type = val[val.length - 1];
      console.log(trigger_field_type.name);
      if (trigger_field_type.name == "master_field") {
        this.getTriggerMasterFields();
        this.triggerFieldgroups[0].triggerField = {};
      }

      if (trigger_field_type.name == "client_field") {
        this.getTriggerCampaignClients();
        this.triggerFieldgroups[0].triggerField = {};
      }
      if (trigger_field_type.client) {
        this.getTriggerClientFields(trigger_field_type.id);
        this.triggerFieldgroups[0].triggerField = {};
      }

      if (trigger_field_type.name == "campaign_field") {
        this.getTriggerCampaignFields();
        this.triggerFieldgroups[0].triggerField = {};
      }
    }
  },
  methods: {
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    addAnother: function() {
      this.sourceFieldgroups.push({
        sourceFieldType: "",
        sourceField: ""
      });
      this.triggerFieldgroups.push({
        triggerFieldType: "",
        triggerField: ""
      });
    },
    addSourceColumn() {
      this.sourceFieldgroups.push({
        sourceFieldType: "",
        sourceField: ""
      });

      this.source_field_types = [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 2,
          name: "client_field",
          value: "client_field",
          label: "Client Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ];
    },
    addTriggerColumn() {
      this.triggerFieldgroups.push({
        triggerFieldType: "",
        triggerField: ""
      });

      this.trigger_field_types = [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 2,
          name: "client_field",
          value: "client_field",
          label: "Client Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ];
    },
    deleteSourceColumn(slot) {
      this.sourceFieldgroups = this.sourceFieldgroups.filter(function(ele) {
        return ele != slot;
      });

      this.source_field_types = [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 2,
          name: "client_field",
          value: "client_field",
          label: "Client Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ];
      // this.triggerFieldgroups = this.triggerFieldgroups.filter(function(ele) {
      //   return ele != slot;
      // });
      // this.fieldgroups.pop(slot);
    },
    deleteTriggerColumn(slot) {
      // this.sourceFieldgroups = this.sourceFieldgroups.filter(function(ele) {
      //   return ele != slot;
      // });
      this.triggerFieldgroups = this.triggerFieldgroups.filter(function(ele) {
        return ele != slot;
      });

      this.trigger_field_types = [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 2,
          name: "client_field",
          value: "client_field",
          label: "Client Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ];
      // this.fieldgroups.pop(slot);
    },
    submitCampaign() {
      self.showFieldSelection = true;
      self.showCampaignSelect = false;
    },
    getSourceMasterFields(result) {
      let self = this;
      this.$store
        .dispatch("campaignsManagement/getAllMasterFields")
        .then(response => {
          this.master_fields = response.data;

          if (result) {
            self.master_fields.forEach(function(ele) {
              if (ele.id == result.source_field_id) {
                self.sourceFieldgroups[0].sourceField = ele;
              }
            });
          }

          this.master_fields.forEach(function(ele, index) {
            ele.label = ele.name;
            ele.field_type = "master_fields";
            ele.group = "Master Fields";
            let ele_name = ele.name;
            ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
            ele.value = ele.name;
          });

          let masterField = {
            group: "Master Fields",
            column_names: this.master_fields
          };

          this.source_options.push(masterField);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getSourceClientFields(client_id, result) {
      let self = this;
      let data = {};
      data.selected_campaign_id = self.selected_campaign_id;
      data.client_id = client_id;
      self.$store
        .dispatch("campaignsManagement/fetchClientFieldsByClientId", data)
        .then(response => {
          if (response) {
            self.client_fields = JSON.parse(response.data);

            if (result) {
              self.client_fields.forEach(function(ele) {
                if (ele.id == result.source_field_id) {
                  self.sourceFieldgroups[0].sourceField = ele;
                }
              });
            }

            self.client_fields.forEach(function(ele, index) {
              ele.label = ele.name;
              ele.group = ele.client_name;
              let ele_name = ele.name;
              ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
              ele.value = ele.name;
            });

            let clientField = {
              group: "Client Fields",
              column_names: self.client_fields
            };

            self.source_options.push(clientField);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getSourceCampaignClients() {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      self.$store
        .dispatch(
          "campaignsManagement/fetchCampaignClients",
          selected_campaign_id
        )
        .then(response => {
          if (response) {
            self.campaign_clients = JSON.parse(response.data);

            self.campaign_clients.forEach(function(ele) {
              ele.id = ele.client_id;
              ele.name = ele.company_name;
              ele.value = ele.company_name;
              ele.label = ele.company_name;
              ele.client = true;
            });
            self.source_field_types = self.campaign_clients;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getTriggerCampaignClients() {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      self.$store
        .dispatch(
          "campaignsManagement/fetchCampaignClients",
          selected_campaign_id
        )
        .then(response => {
          if (response) {
            self.campaign_clients = JSON.parse(response.data);

            self.campaign_clients.forEach(function(ele) {
              ele.id = ele.client_id;
              ele.name = ele.company_name;
              ele.value = ele.company_name;
              ele.label = ele.company_name;
              ele.client = true;
            });
            self.trigger_field_types = self.campaign_clients;

            console.log("Sdfsdfsd", self.trigger_field_types);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getSourceCampaignFields(result) {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchCampaignFields",
          selected_campaign_id
        )
        .then(response => {
          if (response) {
            this.campaign_fields = response.data;

            if (result) {
              self.campaign_fields.forEach(function(ele) {
                if (ele.id == result.source_field_id) {
                  self.sourceFieldgroups[0].sourceField = ele;
                }
              });
            }

            this.campaign_fields.forEach(function(ele, index) {
              ele.label = ele.name;
              ele.group = "Campaign Fields";
              ele.field_type = "campaign_fields";
              let ele_name = ele.name;
              ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
              ele.value = ele.name;
            });

            let campaignField = {
              group: "Campaign Fields",
              column_names: this.campaign_fields
            };

            this.source_options.push(campaignField);
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaign_fields = [];
            return;
          }
          console.error(err);
        });
    },
    getTriggerMasterFields(result) {
      let self = this;
      this.$store
        .dispatch("campaignsManagement/getAllMasterFields")
        .then(response => {
          this.master_fields = response.data;

          if (result) {
            self.master_fields.forEach(function(ele) {
              if (ele.id == result.trigger_field_id) {
                self.triggerFieldgroups[0].triggerField = ele;
              }
            });
          }

          this.master_fields.forEach(function(ele, index) {
            ele.label = ele.name;
            ele.group = "Master Fields";
            let ele_name = ele.name;
            ele.field_type = "master_fields";
            ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
            ele.value = ele.name;
          });

          let masterField = {
            group: "Master Fields",
            column_names: this.master_fields
          };

          this.trigger_options.push(masterField);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getTriggerClientFields(client_id, result) {
      let self = this;
      let data = {};
      data.selected_campaign_id = self.selected_campaign_id;
      data.client_id = client_id;
      self.$store
        .dispatch("campaignsManagement/fetchClientFieldsByClientId", data)
        .then(response => {
          if (response) {
            self.client_fields = JSON.parse(response.data);

            if (result) {
              self.client_fields.forEach(function(ele) {
                if (ele.id == result.trigger_field_id) {
                  self.triggerFieldgroups[0].triggerField = ele;
                }
              });
            }

            self.client_fields.forEach(function(ele, index) {
              ele.label = ele.name;
              ele.group = ele.client_name;
              let ele_name = ele.name;
              ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
              ele.value = ele.name;
            });

            let clientField = {
              group: "Client Fields",
              column_names: self.client_fields
            };

            self.trigger_options.push(clientField);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getTriggerCampaignFields(result) {
      let self = this;
      let selected_campaign_id = self.selected_campaign_id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchCampaignFields",
          selected_campaign_id
        )
        .then(response => {
          if (response) {
            this.campaign_fields = response.data;

            if (result) {
              self.campaign_fields.forEach(function(ele) {
                if (ele.id == result.trigger_field_id) {
                  self.triggerFieldgroups[0].triggerField = ele;
                }
              });
            }

            this.campaign_fields.forEach(function(ele, index) {
              ele.label = ele.name;
              ele.group = "Campaign Fields";
              ele.field_type = "campaign_fields";
              let ele_name = ele.name;
              ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
              ele.value = ele.name;
            });

            let campaignField = {
              group: "Campaign Fields",
              column_names: this.campaign_fields
            };

            this.trigger_options.push(campaignField);
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaign_fields = [];
            return;
          }
          console.error(err);
        });
    },
    submitSelectedFields() {
      let self = this;
      var mergedFieldGroups = [];
      for (var i = 0; i < self.sourceFieldgroups.length; i += 1) {
        let item = {};
        item.sourceField = self.sourceFieldgroups[i].sourceField;
        item.triggerField = self.triggerFieldgroups[i].triggerField;
        mergedFieldGroups.push(item);
      }
      mergedFieldGroups[0].campaign_id = this.selected_campaign_id;
      mergedFieldGroups[0].cascade_field_id = this.cascadeFieldId;

      mergedFieldGroups.forEach(function(ele) {
        if (ele.sourceField.id == ele.triggerField.id) {
          self.$vs.notify({
            color: "danger",
            title: "Cascade Fields",
            text:
              "Cannot choose a same field type for trigger.Please correct it and click on proceed."
          });
          mergedFieldGroups = [];
          return false;
        }
      });

      self.$store
        .dispatch("campaignsManagement/updateCascadeFields", mergedFieldGroups)
        .then(res => {
          if (res.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Cascade Fields",
              text: res.data.message
            });
            self.$router.push({ path: "/campaigns/list-cascade-fields" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    getCascadedField() {
      let self = this;
      this.cascadeFieldId = this.$route.params.cascadeFieldId;
      this.$store
        .dispatch("campaignsManagement/getCascadedField", this.cascadeFieldId)
        .then(response => {
          let result = response.data;

          console.log("RRRR", result);

          if (result) {
            this.selected_campaign_id = result.campaign_id;

            if (result.source_field_type == "master_fields") {
              this.sourceFieldgroups[0].sourceFieldType = {
                id: 1,
                name: "master_field",
                value: "master_field",
                label: "Master Field"
              };

              this.getSourceMasterFields(result);

              // console.log("asdasdasd" , self.master_fields)

              // self.source_options.forEach(function(ele){
              //   if(ele.id == result.source_field_id){
              //     self.sourceFieldgroups[0].sourceField = ele
              //   }
              // })
            }

            if (result.trigger_field_type == "master_fields") {
              this.triggerFieldgroups[0].triggerFieldType = {
                id: 1,
                name: "master_field",
                value: "master_field",
                label: "Master Field"
              };
              this.getTriggerMasterFields(result);
            }

            if (result.source_field_type == "client_fields") {
              this.sourceFieldgroups[0].sourceFieldType = {
                id: 2,
                name: "client_field",
                value: "client_field",
                label: "Client Field"
              };
              this.getSourceClientFields(result.source_client_id, result);

              //          if (source_field_type.client) {
              // }

              // if (source_field_type.name == "client_field") {
              //   this.getSourceCampaignClients();
              // }
            }

            if (result.trigger_field_type == "client_fields") {
              this.triggerFieldgroups[0].triggerFieldType = {
                id: 2,
                name: "client_field",
                value: "client_field",
                label: "Client Field"
              };
              this.getTriggerClientFields(result.trigger_client_id, result);
            }

            if (result.source_field_type == "campaign_fields") {
              this.sourceFieldgroups[0].sourceFieldType = {
                id: 3,
                name: "campaign_field",
                value: "campaign_field",
                label: "Campaign Field"
              };
              this.getSourceCampaignFields(result);
            }

            if (result.trigger_field_type == "campaign_fields") {
              this.triggerFieldgroups[0].triggerFieldType = {
                id: 3,
                name: "campaign_field",
                value: "campaign_field",
                label: "Campaign Field"
              };
              this.getTriggerCampaignFields(result);
            }
          }

          console.log(this.selected_campaign_id);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    this.cascadeFieldId = this.$route.params.cascadeFieldId;
    console.log(this.cascadeFieldId);

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.center-span {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>
